// function for reducing length of string
// example
// very-very-very-looooong-name.svg -> very-ver...name.svg
export const reduceRow = (row: string, rowLength = 27, symbolsFromStart = 14, symbolsFromEnd = -10) => {
    return row.length > rowLength ? `${row.slice(0, symbolsFromStart)}...${row.slice(symbolsFromEnd)}` : row;
};
